// @flow
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const NoticeWrapper = styled.div`
  align-items: center;
  background-color: #f0f3ff;
  bottom: ${({ show }) => (show ? 0 : '-150vh')};
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.15);
  padding: 30px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  transition: bottom 0.4s ease-out;
  width: 100%;
  z-index: 10;
`;

const anchorStyles = {
  textDecoration: 'underline',
  color: '#2196f8',
};

function hasUserAccessedSiteBefore() {
  return localStorage.getItem('naexguide.engagementSession');
}

function hasUserDissmissedCookieNotice() {
  return localStorage.getItem('naexguide.dissmissedCookieNotice');
}

function setEngagementSession() {
  localStorage.setItem(
    'naexguide.engagementSession',
    `session${new Date().getTime()}`,
  );
}

function setDissmissedCookieNotice() {
  localStorage.setItem('naexguide.dissmissedCookieNotice', 'true');
}

export default () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(false);
    setDissmissedCookieNotice();
  };

  useEffect(() => {
    const isFirstTimeUser = hasUserAccessedSiteBefore() === null;
    const hasDismissedNotice = hasUserDissmissedCookieNotice() !== null;

    if (isFirstTimeUser) {
      setEngagementSession();
    }

    setTimeout(() => {
      if (!hasDismissedNotice && !isFirstTimeUser) {
        setShowPopup(true);
      }
    }, 3000);
  }, []);

  return (
    <NoticeWrapper show={showPopup}>
      <div>
        <p>
          This site collects some information using Google Analytics to improve
          your browsing experience.
        </p>
        <p style={{ margin: 0 }}>
          By continuing to use this site, you agree to our{' '}
          <Link style={anchorStyles} to="/terms">
            Terms
          </Link>{' '}
          and{' '}
          <Link style={anchorStyles} to="/privacy-policy">
            Privacy policy
          </Link>
          .
        </p>
      </div>
      <Button variant="contained" color="primary" onClick={handleClick}>
        OK, got it
      </Button>
    </NoticeWrapper>
  );
};
